import * as $ from 'jquery';
import SlimSelect from 'slim-select';

export class Miscellaneous {

  constructor() {
    this.improveHtml5Validation();
    this.triggerSlimSelect();
    // js fallback for responsive forms
    // this.responsiveFormClasses();
    this.indexAZNavigation();
    this.socialMediaPosts();
    this.responsiveTables();
    this.menuSectionScrolling();
    this.addMap();
    this.fixCopyrightWidth();
    this.jsDropdownHandling();
    this.dropdownShowSelected();
    this.handleSolrTypeFilter();
    this.handleSolrMultivalueFacet();
    this.controlImagestageVideo();
    this.shrinkDropdown();
    this.updateShortLink();
    this.extendResetForm();
    this.disablePowermailSubmitButton();
    this.targetBlankLinkHandler();
  }

  protected extendResetForm() {
    $('form').on('reset', function(event) {
      // search for all selects and reset them
      $('select.slimselect', this).each(function() {
        // select no option for multiple fields, or the first available elsewhere
        this.selectedIndex = this.getAttribute('multiple') ? -1 : 0;
        this.dispatchEvent(new CustomEvent('change'));
      });
    });
  }

  protected setResponsiveFormClass(form, width) {
    form!.classList.remove('size-xxl', 'size-xl', 'size-lg', 'size-md', 'size-sm', 'size-xs', 'size-xs');
    if (width >= 1600) {
      form!.classList.add('size-xxl');
    } else if (width >= 1600) {
      form!.classList.add('size-xxl');
    } else if (width >= 1200 && width < 1600) {
      form!.classList.add('size-xl');
    } else if (width >= 992 && width < 1200) {
      form!.classList.add('size-lg');
    } else if (width >= 768 && width < 992) {
      form!.classList.add('size-md');
    } else if (width >= 576 && width < 768) {
      form!.classList.add('size-sm');
    } else if (width >= 440 && width < 576) {
      form!.classList.add('size-xs');
    } else if (width < 440) {
      form!.classList.add('size-xxs');
    }
  }

  protected responsiveFormClasses() {
    // set width classes to forms depending on its real width
    let self = this;
    const forms = document.querySelectorAll('.tx-powermail form');
    Array.prototype.slice.call(forms).forEach( function(element) {
      self.setResponsiveFormClass(element, element.offsetWidth);
      window.onresize = function(event) {
        self.setResponsiveFormClass(element, element.offsetWidth);
      };
    });
  }

  protected triggerSlimSelect() {
    // select box styling via sim-select
    const selects = document.querySelectorAll('.slimselect');
    Array.prototype.slice.call(selects).forEach( function(element) {
      let select = new SlimSelect({
        select: element,
        showContent: 'auto',
        beforeOpen: function () {
          if ($(this.select.element).parent('.select-wrapper') !== undefined) {
            let bodyRect = document.body.getBoundingClientRect(),
                elementRect = $(this.select.element).parent('.select-wrapper')[0].getBoundingClientRect(),
                footerRect = $('footer.footer')[0].getBoundingClientRect(),
                elementFooterDiff = footerRect.top - elementRect.top;
            if (elementFooterDiff < 300) {
              this.config.showContent = 'up';
            }
          }
        },
      });
    });
  }

  protected improveHtml5Validation() {
    // improve html 5 form validation
    // mixed with jquery for better browser compatibility
    const inputs = document.querySelectorAll('input, select, textarea');
    Array.prototype.slice.call(inputs).forEach( function(input) {
    // inputs.forEach(input => {
      // remove error class on change
      input.addEventListener(
        'keyup',
        event => {
          input.classList.remove('error');
          $(input).closest('.form-group').removeClass('error');
        },
        false
      );
      // add error class on invalid and print html 5 validation message
      input.addEventListener(
        'invalid',
        event => {
          event.preventDefault();
          input.classList.add('error');
          $(input).closest('.form-group').addClass('error');
          $(input).closest('.form-group').find('.form-error').html((<any>input).validationMessage);
          let test = $('.form-group.error:visible:first')[0];
          $('html, body').animate({scrollTop: test.getBoundingClientRect().top + window.pageYOffset - 60}, 300);
        },
        false
      );
    });
  }

  protected indexAZNavigation() {
    $('.frame--type-menu_indexaz').each(function() {
      let indexAZ = $(this);
      indexAZ.find('ul.initials span.link').each(function() {
        $(this).addClass('disabled');
        if (indexAZ.find('ul.keywords > li[data-initial="' + $(this).data('initial') + '"]').length) {
          $(this).removeClass('disabled');
          // index navigation click
          $(this).on('click', function() {
            // hide all keywords
            indexAZ.find('ul.keywords > li').addClass('hidden');
            indexAZ.find('ul.initials span.link').removeClass('active');
            // unhide selected keywords
            indexAZ.find('ul.keywords > li[data-initial="' + $(this).data('initial') + '"]').removeClass('hidden');
            $(this).addClass('active');
            indexAZ.find('.current-initial').html($(this).data('initial'));
          });
        }
      });
      indexAZ.find('ul.keywords > li').each(function() {
        $(this).addClass('hidden');
      });
      if (indexAZ.find('ul.initials span.link').not('.disabled').length) {
        let intitial =  indexAZ.find('ul.initials span.link').not('.disabled').first().data('initial');
        indexAZ.find('ul.initials span.link').not('.disabled').first().addClass('active');
        indexAZ.find('ul.keywords > li[data-initial="' + intitial + '"]').removeClass('hidden');
        indexAZ.find('.current-initial').html(intitial);
      }
    });
  }

  public readCookie(name) {
    let nameEQ = name + '=';
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  public createCookie(name, value, days?) {
    let expires = '';
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + value + expires + '; path=/; SameSite=Strict;';
  }

  public deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Strict;';
  }

  protected showSocialMediaPosts($posts) {
    let self = this;
    $posts.each(function() {
      $(this).addClass('show')
        .find('.post-target').html($(this).attr('data-content'));
      // refresh to fetch the post properly
      const type = $(this).data('type');
      const target = $(this).find('.post-target')[0];
      if (typeof FB !== 'undefined' && type === 'facebook') {
        FB.XFBML.parse(target);
      } else if (typeof instgrm !== 'undefined' && type === 'instagram') {
        instgrm.Embeds.process(target);
      } else if (typeof twttr !== 'undefined' && type === 'twitter') {
        twttr.widgets.load(target);
      } else if (type === 'mastodon') {
          // todo: replace by proper Mastodon embed script once released
          let iframe = target.querySelectorAll('iframe')[0];
          window.addEventListener('message', self.refreshIframeHeight);
          iframe.onload = function () {
              iframe.contentWindow?.postMessage(
                {
                  type: 'setHeight',
                  id: $(target).parents('.frame--type-socialmediapost').attr('id'),
                },
                '*'
              );
          };
      }
    });
  }

  // todo: remove workaround after upgrading Mastodon
  public refreshIframeHeight(event) {
      let data = event.data || {};
      if (typeof data !== 'object' || data.type !== 'setHeight' || document.getElementById(data.id) === null) {
          return;
      }
      let iframe = document.getElementById(data.id)?.querySelector('iframe');
      if (iframe) {
          iframe.height = data.height;
      }
  }

  protected hideSocialMediaPosts($posts) {
    $posts
      .removeClass('show')
      .find('.post-target').html('');
  }

  protected socialMediaPosts() {
    let self = this;
    const cookie = JSON.parse(self.readCookie('extcontent_optin_social') ?? '{}');
    // show posts if optin cookie for external stream exists
    $('.social-media-post')
      .each(function() {
        const provider = $(this).data('provider');
        // check if optin cookie for type exists
        if (provider in cookie) {
          self.showSocialMediaPosts($(this));
        }
      })
      .on('click', '.social-media-post-optin', function() {
        const $post = $(this).parent('.social-media-post');
        const provider = $post.data('provider');
        let optin = JSON.parse(self.readCookie('extcontent_optin_social') ?? '{}');

        if (provider in optin) {
          delete optin[provider];
          self.hideSocialMediaPosts($('.social-media-post[data-provider="' + provider + '"]'));
        } else {
          optin[provider] = true;
          self.showSocialMediaPosts($('.social-media-post[data-provider="' + provider + '"]'));
        }
        // save cookie with updated values
        self.createCookie('extcontent_optin_social', JSON.stringify(optin));
      });
  }

  protected responsiveTables() {
    // add transposed vertical table
    $('.ce-table.table-headerposition-2').each(function() {
      let mobileTable = $(this).clone();
      mobileTable.addClass('mobile');
      mobileTable.prepend($('<thead></thead>'));
      let newRows = [] as any;
      mobileTable.find('tr').each(function() {
        let i = 0;
        $(this).find('td, th').each(function() {
          let cell = $(this).clone();
          i++;
          if (newRows[i] === undefined) {
            newRows[i] = $('<tr></tr>');
          }
          newRows[i].append(cell);
        });
      });
      mobileTable.find('tr').remove();
      $.each(newRows, function(index) {
        if (index === 1) {
          mobileTable.find('thead').append(this);
        } else {
          mobileTable.find('tbody').append(this);
        }
      });
      $(this).parent().append(mobileTable);
    });
    // add label to data cells
    $('.ce-table.table-headerposition-1, .ce-table.mobile').each(function() {
      let headerCount = $(this).find('thead th').length;
      for (let i = 0; i <= headerCount; i++) {
        let headerLabel = $(this).find('thead th:nth-child(' + i + ')').text().trim();
        let headerLabelClass = '';
        if (headerLabel.length === 0) {
          headerLabelClass = 'no-header';
        }
        $(this).find('tr td:nth-child(' + i + ')').replaceWith(
          function () {
            return $('<td data-label="' + headerLabel + '">').addClass(headerLabelClass).append($(this).contents());
          }
        );
      }
    });
  }

  protected menuSectionScrolling() {
    // smooth scrolling for anchor links
    $('a[data-anchor]').on('click', function(event) {
      let target = $('#' + $(this).data('anchor')).first();
      if (target) {
        event.preventDefault();
        let targetTop = target.offset()!.top;
        $('html, body').animate({scrollTop: targetTop - 120}, 300);
      }
    });
  }

  public leaflet(L, value) {
    let map, miniMap, bound;

    map = L.map('map_' + value.id, {
      zoomControl: value.data.mapConf.zoomControl,
      minZoom: value.data.mapConf.minZoom,
      maxZoom: value.data.mapConf.maxZoom,
      animate: value.data.mapConf.animate,
      scrollWheelZoom: value.data.mapConf.scrollWheelZoom
    });

    L.tileLayer(value.data.tileLayer, value.data.attribution).addTo(map);

    if (value.data.mapConf.displayZoomButtons === 1) {
      L.control.zoom(value.data.zoomOptions).addTo(map);
    }

    if (typeof value.data.tileLayer2 !== 'undefined' &&
        typeof value.data.attribution2 !== 'undefined') {
      L.tileLayer(value.data.tileLayer2, value.data.attribution2).addTo(map);
    }

    if (value.data.markers.length > 0) {
      let markers_data = [{
        latlng: [
          value.data.markers[0].latlng?.[0],
          value.data.markers[0].latlng?.[1]
        ],
        popup: value.data.markers[0].popup,
        icon: value.data.markers[0].icon,
        shadow: value.data.markers[0].shadow
      }], group = new L.featureGroup([]), marker, i = 0;

      let mapMarkers = [];

      while (marker = value.data.markers[i++]) {
        let LeafIcon = L.Icon.extend({
          options: {
            shadowUrl: marker.shadow,
            iconSize: [25, 41],
            shadowSize: [60, 74],
            iconAnchor: [12, 41],
            shadowAnchor: [31, 51],
            popupAnchor: [0, -40]
          }
        });
        let customMarker = new LeafIcon({
          iconUrl: marker.icon
        });
        let mapMarker = new L.marker(marker.latlng, {
          icon: customMarker
        });

        if (value.data.mapConf.popupOptions > 1) {
          mapMarker.bindPopup(marker.popup);
        }
        group.addLayer(mapMarker);
        mapMarkers.push(mapMarker);
      }
    }

    if (typeof group !== 'undefined') {
      bound = group.getBounds();
    } else {
      // latitude 52.512299, Longitude 13.32697 is Straße des 17. Juni 135, 10623 Berlin
      bound = [
        [52.512299, 13.32697],
        [52.512299, 13.32697]
      ];
      group = new L.featureGroup([]);
    }

    map.fitBounds(bound, {
      padding: [25, 25],
      maxZoom: value.data.maxZoom
    }).addLayer(group);

    if (value.data.mapConf.displayFullScreenButton === 1) {
      map.addControl(new L.Control.Fullscreen({
        title: {
          'false': value.data.fullscreen.title.false,
          'true': value.data.fullscreen.title.true
        }
      }));
    }

    if (value.data.mapConf.displayMiniMap) {
      if (typeof map !== 'undefined') {
        miniMap = new L.Control.MiniMap(value.data.osm2, {toggleDisplay: true}).addTo(map);
      }
    }

    if (typeof value.data.captionLinks !== 'undefined') {
      for (let cl = 0; cl < value.data.captionLinks.length; cl++) {
        // save openPopup logic on the object itself (useful for removeEventListener later)
        value.data.captionLinks[cl].openPopup = function _openPopup(ev) {
          ev.stopImmediatePropagation();
          if (typeof map !== 'undefined') {
            mapMarkers[cl].openPopup();
            map.setView(mapMarkers[cl].getLatLng());
            if (this.blur)this.blur();
          }
        };
        value.data.captionLinks[cl].addEventListener('click', value.data.captionLinks[cl].openPopup);
      }
    }

    return {map, miniMap};
  }

  public setOSMCookie() {
    let self = this;
    if (!self.hasOSMCookie()) {
      self.createCookie('extcontent_optin_OSM', 'true');
    }
  }

  public hasOSMCookie() {
    return this.readCookie('extcontent_optin_OSM');
  }


  public initMapProperties(map, miniMap) {
    let self = this;
    for (let key in mapData) {
      if (!mapData.hasOwnProperty(key)) { continue; }
      let leaflet = self.leaflet(L, mapData[key]);
      map[key] = leaflet.map;
      miniMap[key] = leaflet.miniMap;
    }
  }

  public removeMapProperties(map, miniMap) {
    for (let key in mapData) {
      if (!mapData.hasOwnProperty(key)) { continue; }
      map[key].off();
      map[key].remove();

      if (typeof miniMap[key] !== 'undefined') {
        miniMap[key].off();
        miniMap[key].remove();
      }

      // remove captionLinks eventListeners
      if (typeof mapData[key].data.captionLinks !== 'undefined') {
        for (let cl = 0; cl < mapData[key].data.captionLinks.length; cl++) {
          mapData[key].data.captionLinks[cl].removeEventListener('click', mapData[key].data.captionLinks[cl].openPopup);
        }
      }

      // remove maps data
      map[key] = miniMap[key] = null;
    }
  }

  protected addMap() {
    let self = this;

    if (typeof L !== 'undefined') {

      let map = [];
      let miniMap = [];
      let $osmWrappers = $('.osm-wrapper');

      for (let key in mapData) {
        if (!mapData.hasOwnProperty(key)) { continue; }
        $('#map_' + key).parent('.osm-wrapper').css({
          'width': mapData[key].data.mapConf.mapWidth,
          'height': mapData[key].data.mapConf.mapHeight,
          'border-radius': mapData[key].data.mapConf.borderRadiusMap
        });
      }

      if (self.hasOSMCookie()) {
        // wait until all elements are loaded before auto-initializing maps
        $(window).one('load', function() {
          $osmWrappers.addClass('activated');
          self.initMapProperties(map, miniMap);
        });
      }

      $('.osm-optin [type=checkbox]').on('change', function (event) {
        if (self.hasOSMCookie()) {
          self.deleteCookie('extcontent_optin_OSM');
          self.removeMapProperties(map, miniMap);
          $osmWrappers.removeClass('activated');
        } else {
          $osmWrappers.addClass('activated');
          self.setOSMCookie();
          self.initMapProperties(map, miniMap);
        }
      });
    }
  }

  protected fixCopyrightWidth() {
    // set copyright width class depending on image dimensions
    setTimeout(
      function() {
        $('small.copyright').each(function() {
          let image = $(this).parent('.img-wrap').find('img').first();
          if (image.height()! > 0) {
            let imageRatio = Math.floor(image.height()! * 10 / image.width()!);
            $(this).addClass('image-ratio-' + imageRatio);
          }
        });
      },
      100
    );
  }

  protected jsDropdownHandling() {
    // add blur element to drop down
    $('.select').not('.headerMenu, .headerMenu--mobile').each(function(index) {
      let selectElement = $(this);
      // add unique class identifier
      let selectIdentifier = 'selectid-' + index;
      selectElement.addClass(selectIdentifier);
      // adding blur helper element
      let selectBlur = document.createElement('span');
      selectBlur.setAttribute('class', 'select__blur');
      selectElement.append(selectBlur);
      $(selectBlur).on('click', function() {
        selectElement.removeClass('focus');
      });
      // add focus helper element
      let selectFocus = document.createElement('span');
      selectFocus.setAttribute('class', 'select__focus');
      selectElement.append(selectFocus);
      $(selectFocus).on('click', function() {
        selectElement.addClass('focus');
      });
      $(document).on('click', function(event) {
        if (!$(event.target).hasClass(selectIdentifier) && $(event.target).parents('.' + selectIdentifier).length === 0) {
          selectElement.removeClass('focus');
        }
      });
    });
  }

  protected handleSolrTypeFilter() {
    // special handling for type facet in solr
    $('.select.facetList__type').each(function() {
      let facet = $(this);
      let solrBaseUrl = $(this).find('.solrBaseUrl').val();
      $(this).find('a').on('click', function(event) {
        event.preventDefault();
        if ($(this).parent().hasClass('disabled')) {
            return false;
        }
        facet.find('.button.facetList__submit').removeClass('disabled');
        if ($(this).parent().hasClass('all-types')) {
          facet.find('.facetList__itemOptionListItem.selected:not(.all-types)').removeClass('selected');
          $(this).parent().addClass('selected');
        } else {
          $(this).parent().toggleClass('selected');
          facet.find('.facetList__itemOptionListItem.all-types').removeClass('selected');
          if (facet.find('.facetList__itemOptionListItem.selected:not(.all-types)').length === 0) {
            facet.find('.facetList__itemOptionListItem.all-types').addClass('selected');
          }
        }
      });
      facet.find('.button.facetList__submit').on('click', function(event) {
        event.preventDefault();
        if ($(this).hasClass('disabled')) {
          return false;
        }
        // get selected types
        let solrFilter = '';
        facet.find('.facetList__itemOptionListItem.selected:not(.all-types)').each(function(index) {
          solrFilter += '&tx_solr[filter][]=' + $(this).data('facet-item-value');
        });
        window.location.replace(String(facet.find('input.solrBaseUrl').val()!) + solrFilter);
      });
    });
  }

  protected handleSolrMultivalueFacet() {
    // special handling for multi value facet in solr
    let self = this;
    $('.select.facetList__multi').each(function() {
      let facet = $(this);
      let facetBaseUrl = String($(this).find('.facetBaseUrl').val());
      let facetPluginNamespace = $(this).find('.facetPluginNamespace').val();
      $(this).find('a').on('click', function(event) {
        event.preventDefault();
        if ($(this).parent().hasClass('disabled')) {
            return false;
        }
        facet.find('.button.facetList__submit').removeClass('disabled');
        if ($(this).parent().hasClass('all-options')) {
          facet.find('.facetList__itemOptionListItem.selected:not(.all-options)').removeClass('selected');
          $(this).parent().addClass('selected');
        } else {
          $(this).parent().toggleClass('selected');
          facet.find('.facetList__itemOptionListItem.all-options').removeClass('selected');
          if (facet.find('.facetList__itemOptionListItem.selected:not(.all-options)').length === 0) {
            facet.find('.facetList__itemOptionListItem.all-options').addClass('selected');
          }
        }
      });
      let querySeparator = '?';
      if (facetBaseUrl.lastIndexOf('?') > -1) {
        querySeparator = '&';
      }
      facet.find('.button.facetList__submit').on('click', function(event) {
        event.preventDefault();
        if ($(this).hasClass('disabled')) {
          return false;
        }
        // get selected types
        let solrFilter = '';
        facet.find('.facetList__itemOptionListItem.selected:not(.all-options)').each(function(index) {
          solrFilter += querySeparator + facetPluginNamespace + '[filter][]=' + $(this).data('facet-item-value');
          querySeparator = '&';
        });
        window.location.replace(facetBaseUrl + solrFilter);
      });
    });
  }

  protected dropdownShowSelected() {
    // show selected option in closed drop down
    $('.select__showselected').each(function() {
      let selectedItem = $(this).find('.select__listItem.selected').first();
      if (selectedItem.data('facet-item-label') !== undefined) {
        $(this).find('.select__label').text(selectedItem.data('facet-item-label'));
      }
    });
  }

  protected controlImagestageVideo() {
    // controls imagestage video player
    let self = this;
    $('.imagestage.imagestage--video').each(function() {
      let videoContainer = $(this);
      let video = videoContainer[0].querySelector('video');
      if (video !== null) {
        let videoImage = $(this).find('.video-image').first();
        let videoControls = $(this).find('.video-controls').first();
        let videoPlay = $(this).find('.video-controls .action--play').first();
        let videoPause = $(this).find('.video-controls .action--pause').first();
        let videoMute = $(this).find('.video-controls .action--mute').first();
        let videoUnmute = $(this).find('.video-controls .action--unmute').first();

        // status on load
        if (video.paused || video.ended) {
          videoContainer.removeClass('status--play').addClass('status--pause');
        } else {
          videoContainer.removeClass('status--pause').addClass('status--play');
          videoImage!.hide(0);
          self.hideVideoControls(videoControls);
        }
        if (video.muted) {
          videoContainer.removeClass('status--unmute').addClass('status--mute');
        } else {
          videoContainer.removeClass('status--mute').addClass('status--unmute');
        }
        video.addEventListener('ended', function(e) {
          videoContainer!.removeClass('status--play').addClass('status--pause');
        });
        video.addEventListener('play', function(e) {
          videoContainer.removeClass('status--pause').addClass('status--play');
          videoImage!.hide(0);
          self.hideVideoControls(videoControls);
        });
        video.addEventListener('volumechange', function(e) {
          if (video!.muted) {
            videoContainer.removeClass('status--unmute').addClass('status--mute');
          } else {
            videoContainer.removeClass('status--mute').addClass('status--unmute');
          }
          self.hideVideoControls(videoControls);
        });

        // show / hide video controls
        videoContainer.on('click mousemove', function(e) {
          if (videoControls!.hasClass('inactive')) {
            videoControls!.removeClass('inactive');
            self.hideVideoControls(videoControls);
          }
        });

        // control events
        videoPlay!.on('click', function(e) {
          video!.play();
          videoContainer!.removeClass('status--pause').addClass('status--play');
          videoImage!.hide(0);
        });
        videoPause!.on('click', function(e) {
          video!.pause();
          videoContainer!.removeClass('status--play').addClass('status--pause');
        });
        videoMute!.on('click', function(e) {
          video!.muted = !video!.muted;
          videoContainer!.removeClass('status--unmute').addClass('status--mute');
        });
        videoUnmute!.on('click', function(e) {
          video!.muted = !video!.muted;
          videoContainer!.removeClass('status--mute').addClass('status--unmute');
        });
      }
    });
  }

  protected hideVideoControls(videoControls) {
    setTimeout(
      function() {
         videoControls!.addClass('inactive');
       },
      5000
    );
  }

  protected shrinkDropdown() {
    // shrink drop down nearby footer
    const selects = document.querySelectorAll('.select__list.scrollable');
    Array.prototype.slice.call(selects).forEach( function(element) {
      let elementRect = $(element).parent()[0].getBoundingClientRect(),
          footerRect = $('footer.footer')[0].getBoundingClientRect(),
          elementFooterDiff = footerRect.top - elementRect.top;
      if (elementFooterDiff < 400) {
        element.classList.add('small');
      }
    });
  }

  protected updateShortLink() {
    // replace the footer short link on detail pages with a more specific uri
    const shortLink = $('[data-short-link]').first();
    if (shortLink && shortLink.data('shortLink') !== '') {
      const uri = shortLink.data('shortLink');
      const permalink = $('.footer__permalink').first();
      if (permalink && permalink.children('a').first()) {
        let link = permalink.children('a').first();
        link.attr('href', uri);
        link.text(uri);
      }
    }
  }

  protected disablePowermailSubmitButton() {
    $('.tx-powermail form').on('submit', function() {
      $(this).find('input[type="submit"]')
        .attr('disabled', 'true')
        .addClass('button--in-progress');
    });
  }

  protected targetBlankLinkHandler() {
    // rel="noopener" workaround for IE <= 11
    const ua = window.navigator.userAgent;
    if (ua.indexOf('MSIE ') > 0 || ua.indexOf('Trident/') > 0) {
      $('a[target="_blank"][rel~="noopener"]')
        .on('click', function (event) {
          let newTab = window.open();
          newTab.opener = null;
          newTab.location = $(this).attr('href');
          event.stopPropagation();
          return false;
        });
    }
  }
}
